const MILITARY_STATUS_CODE = {
  NO_SELECTION: '0-0',
  NO_AFFILIATION: '0-1',
  PREFER_NOT_TO_ANSWER: '0-2',
  ACTIVE_DUTY: '1',
  RETIRED_VETERAN: '2',
  RESERVE: '3',
};

const militaryStatuses = [
  {
    value: MILITARY_STATUS_CODE.NO_AFFILIATION,
    labelKey: 'dmvrr_militaryStatus_noAffiliation',
    fallback: 'No military affiliation',
  },
  {
    value: MILITARY_STATUS_CODE.ACTIVE_DUTY,
    labelKey: 'dmvrr_militaryStatus_activeDuty',
    fallback: 'Active duty',
  },
  {
    value: MILITARY_STATUS_CODE.RETIRED_VETERAN,
    labelKey: 'dmvrr_militaryStatus_retiredVeteran',
    fallback: 'Retired or veteran',
  },
  {
    value: MILITARY_STATUS_CODE.RESERVE,
    labelKey: 'dmvrr_militaryStatus_reserve',
    fallback: 'Reserve',
  },
  {
    value: MILITARY_STATUS_CODE.PREFER_NOT_TO_ANSWER,
    labelKey: 'dmvrr_militaryStatus_preferNotToAnswer',
    fallback: 'Prefer not to answer',
  },
];

export default militaryStatuses;

export const mapMilitaryStatusCodeToInternalValue = militaryStatusCode => {
  return militaryStatuses.some(status => status.value === militaryStatusCode)
    ? militaryStatusCode
    : undefined;
};

export const resolveMilitaryStatusCode = militaryStatusCode => {
  return (
    mapMilitaryStatusCodeToInternalValue(militaryStatusCode) ||
    MILITARY_STATUS_CODE.NO_SELECTION
  );
};
